import type { FunctionComponent } from 'react';
import DefaultImage from '../../../shared-components/DefaultImage/DefaultImage';
import defaultImage from '../../Product/default-image.png';
import { ReactComponent as SurpriseMeIcon } from '../../Product/surprise-me-icon.svg';
import * as styles from './styles.module.scss';

type ItemImageProps = {
  brandName?: string | null;
  name: string;
  imageUrl: string;
  autoAssigned: boolean;
  slug: string;
};

const ItemImage: FunctionComponent<ItemImageProps> = ({
  brandName = null,
  name,
  imageUrl,
  autoAssigned,
  slug,
}) => {
  const productName = brandName ? `${brandName} ${name}` : name;
  const productUrl = `/product/${slug}`;

  return (
    <li className={styles.item} data-testid="item-image">
      {autoAssigned ? (
        <SurpriseMeIcon className={styles.surprise} />
      ) : (
        <a href={productUrl} target="_blank" rel="noreferrer">
          <figure>
            <DefaultImage src={imageUrl} defaultImage={defaultImage} alt={productName} />
          </figure>
        </a>
      )}
    </li>
  );
};

export default ItemImage;
